export default __webpack_public_path__ + "static/media/app_image_1.9dfb7171.png";